import { DeficiencyCoreBase } from "./deficiency.core.base"


export class DeficiencyCore extends DeficiencyCoreBase {

}